import {
  INSPECTION_STATUSES,
  INSPECTION_STATUSES_CONFIG,
} from "@miplatform/constants";
import {
  IInspectionAttempt,
  InspectionActionTypes,
  PopperPlacement,
} from "@miplatform/types";
import { getInspectionMenuItems } from "@miplatform/utils";
import { mdiTag } from "@mdi/js";
import { useTheme } from "@mui/material";
import { MiWorkCard } from "../MiWorkCard/MiWorkCard";
import { MiInspectionPopper } from "./MiInspectionPopper";

export const MiInspectionCard = ({
  data,
  headerColor,
  onMenuItemClick,
  popperPlacement,
}: {
  data: IInspectionAttempt;
  headerColor?: string;
  onMenuItemClick?: ({
    inspectionAttempt,
    actionType,
  }: IInspectionMenuAction) => void;
  popperPlacement?: PopperPlacement;
}) => {
  const theme = useTheme();

  const menuItems = getInspectionMenuItems({
    data,
    onMenuItemClick,
    theme,
  });

  const { templateName, attemptStatus, home, approvedStartDate } = data;

  const headerIcon =
    attemptStatus === INSPECTION_STATUSES.FAILED
      ? { path: mdiTag, color: theme.palette.error.main }
      : null;

  return (
    <MiWorkCard
      title={templateName}
      displayDate={approvedStartDate}
      status={attemptStatus}
      headerIcon={headerIcon}
      home={home}
      statusConfig={INSPECTION_STATUSES_CONFIG}
      headerColor={headerColor}
      menuItems={menuItems}
      popperPlacement={popperPlacement}
      popperComponent={
        <MiInspectionPopper inspection={data} headerColor={headerColor} />
      }
    />
  );
};

export interface IInspectionMenuAction {
  inspectionAttempt: IInspectionAttempt;
  actionType?: InspectionActionTypes | null;
}
